"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonsComponent = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../gen-src/Localize");
var ProtocolHelper_1 = require("./ProtocolHelper");
var DialogStyles_1 = require("./styles/DialogStyles");
var TelemetryConstants = require("./telemetry/TelemetryConstants");
var TelemetryHelper_1 = require("./telemetry/TelemetryHelper");
var ButtonsComponent = /** @class */ (function (_super) {
    __extends(ButtonsComponent, _super);
    function ButtonsComponent(props) {
        var _this = _super.call(this, props) || this;
        TelemetryHelper_1.TelemetryHelper.addOrUpdateTelemetry(TelemetryConstants.RetryCount, 0);
        TelemetryHelper_1.TelemetryHelper.addOrUpdateTelemetry(TelemetryConstants.PrimaryActionCount, 0);
        return _this;
    }
    ButtonsComponent.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: DialogStyles_1.DialogStyles.BottomButtons },
            React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, onClick: function (e) { return _this.handleRetry(); }, testId: "ce-retry-button", children: Localize_1.Messages.RetryButtonLabel() }),
            React.createElement(widgets_1.ButtonWidget, { className: DialogStyles_1.DialogStyles.PrimaryButton, buttonType: widgets_1.ButtonType.Primary, onClick: function (e) { return _this.handlePrimaryAction(); }, testId: "ce-primary-button", children: this.props.primaryButtonLabel })));
    };
    ButtonsComponent.prototype.handleRetry = function () {
        ProtocolHelper_1.OpenTableau(this.props.workbookInfo);
        TelemetryHelper_1.TelemetryHelper.addOrIncrementTelemetryCounter(TelemetryConstants.RetryCount);
    };
    ButtonsComponent.prototype.handlePrimaryAction = function () {
        TelemetryHelper_1.TelemetryHelper.addOrIncrementTelemetryCounter(TelemetryConstants.PrimaryActionCount);
        this.props.handlePrimaryAction();
    };
    return ButtonsComponent;
}(React.PureComponent));
exports.ButtonsComponent = ButtonsComponent;
//# sourceMappingURL=ButtonsComponent.js.map